export const SET_COMPLETED_STATUS = 'SET_COMPLETED_STATUS';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';